import React from "react";
import { Form } from "react-bootstrap";
import { usCurrency } from "../../../utils";

const SourceCard = ({ data, onChange, setFieldValue, values }) => {
  return (
    <>
      {data &&
        data.map((item, index) => (
          <div
            className={
              item.checked ? "source-card-active mr-3" : "source-card mr-3"
            }
            onClick={() => onChange(index, { values, setFieldValue })}
          >
            <div className="d-flex justify-content-between">
              <div className="ft-14 fw-500">{item.sourceName}</div>
              <Form.Check
                name={`sources${index}`}
                type="checkbox"
                label=""
                id={`sources${index}`}
                style={{ marginTop: "2px" }}
                checked={item.checked}
              />
            </div>
            <span className="ft-14 grey-text">
              {usCurrency(item.sourceBalance)}
            </span>
          </div>
        ))}
    </>
  );
};

export default SourceCard;
